import styled from "styled-components";
import { breakpoints } from "../../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 320px;
  background-color: var(--white);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;

  button {
    width: 100%;
    border: 2px solid var(--white);
    background-color: var(--white);
    color: var(--black);
    border-radius: 12px;
    padding: 10px 0px 10px 25px;
    margin: 0px 0px 15px 0px;
    cursor: pointer;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 1.5em;
    text-align: left;
    position: relative;
    transition: 0.1s all;
  }

  button i {
    position: absolute;
    right: 25px;
    top: calc(55% - 10px);
    width: 10px;
    height: 10px;
    display: block;
    border-left: 3px solid var(--lightgray);
    border-bottom: 3px solid var(--lightgray);
    transform: rotate(-135deg);
    z-index: 99;
    border-radius: 10%;
    transition: 0.1s all;
  }

  button:hover > i {
    border-left: 3px solid var(--orange);
    border-bottom: 3px solid var(--orange);
  }

  .active {
    border: 2px solid var(--orange);
  }

  .active i {
    border-left: 3px solid var(--orange);
    border-bottom: 3px solid var(--orange);
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    button {
      font-size: 1.4em;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    button {
      font-size: 1.3em;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    button {
      margin-right: 0px !important;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    button {
      text-align: center;
      border: 2px solid var(--lightgray);
      padding: 10px 0px 10px 0px;
    }

    button i {
      display: none;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;
    margin: 0 auto;
  }
`;

export default Container;
